module.exports = __webpack_public_path__ + "static/media/chaimaa11.ca6d2a13.png";